import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LiveDotProps {
    className?: string
    tone?: 'coral' | 'signal' | 'ultramarine'
    pulse?: boolean
}

const TONES = {
    coral: 'bg-coral',
    signal: 'bg-signal',
    ultramarine: 'bg-ultramarine'
}

/** The small "live" dot. Coral is reserved for live and status moments. */
export const LiveDot: FC<LiveDotProps> = ({ className, tone = 'coral', pulse = true }): ReactNode => {
    return (
        <span aria-hidden='true' className={cn('relative inline-flex size-2 shrink-0', className)}>
            {pulse && (
                <span className={cn('absolute inset-0 rounded-full animate-pulse-ring', TONES[tone])} />
            )}

            <span className={cn('relative inline-flex size-2 rounded-full', TONES[tone])} />
        </span>
    )
}
